import styled, { StyledComponent } from 'styled-components/macro';
import { slideArrowIn, slideArrowOut } from '../../animations/keyframes';
import { Icon24 } from '../Icon';

interface ArrowProps {
  parentHover: StyledComponent<any, any>;
}

const Arrow = styled.img<ArrowProps>`
  ${Icon24}
  ${(props) => props.parentHover}:hover & {
    animation: ${slideArrowIn} 300ms cubic-bezier(0.1, -0.85, 0.57, 1.85)
      forwards;
  }
  ${(props) => props.parentHover}:not(:hover) & {
    animation: ${slideArrowOut} 250ms cubic-bezier(0.1, -0.85, 0.57, 1.85)
      forwards;
  }
`;

export default Arrow;
